import styled from 'styled-components'

const PanelSection = styled.div`
  padding: 10px 0 0 0;
`

export default PanelSection
